import ModalForm from 'assets/components/form/modalForm/ModalForm';
import ThemeModalFormDefault from 'assets/components/form/modalForm/themes/Theme.ModalForm.Default';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import DateInput from 'assets/components/inputs/dateInput/DateInput';
import { getLocales } from 'assets/locales/Locale';
import { defaultDateFormat, defaultServerDateTimeFormat } from 'assets/utils/data/Date';
import dayjs from 'dayjs';
import { addLog } from 'assets/components/feedback/Feedback';
import { HttpStatus } from 'config/Api.Config';
import ContractStatusCode from 'models/enums/ContractStatusCode';
import contractSetStatusApi from 'models/sales/contract/setStatus/Api.Contract.SetStatus';
import { useSalesContractProvider } from '../Sales.Contract.Hooks';

type IRequest = {
  contractId: number;
  paidOnLocalDate?: string;
};

export default function ContractPaidActiveModal() {
  const { lang } = getLocales();
  const { listApi, pageRouter, setIsStatusChanging } = useSalesContractProvider();

  const contractId = Number((pageRouter.params as any)?.id);

  return (
    <ModalForm<IRequest>
      subcomponents={ThemeModalFormDefault}
      title={lang.changeStatus}
      default={{
        contractId,
        paidOnLocalDate: dayjs().startOf('day').format(defaultServerDateTimeFormat),
      }}
      onCancel={pageRouter.updateParams}
      validation={(data, errors) => {
        if (!data.paidOnLocalDate) errors.paidOnLocalDate = lang.mustNotBeEmpty;
      }}
      onSubmit={async (data) => {
        setIsStatusChanging(true);

        const res = await contractSetStatusApi(data.contractId, {
          newStatus: ContractStatusCode.PAID_ACTIVE,
          triggerStatusFlow: true,
          paidOnLocalDate: data.paidOnLocalDate,
        } as any);

        setIsStatusChanging(false);

        if (res.status === HttpStatus.ok) {
          addLog({ success: lang.contractStatusSuccesfullyChanged });
          pageRouter.updateParams();
          listApi.execute((b) => b);
        } else {
          addLog({ error: res.message });
        }
      }}
      render={({ form }) => (
        <FormWrapper>
          <DateInput
            isLocal
            name="paidOnLocalDate"
            label={lang.datePaymentReceived}
            error={form.errors.paidOnLocalDate}
            dateTimeFormat={defaultDateFormat}
            min={dayjs().startOf('day').subtract(3, 'day').format(defaultServerDateTimeFormat)}
            max={dayjs().endOf('day').format(defaultServerDateTimeFormat)}
            value={form.data.paidOnLocalDate}
            onChange={form.update}
          />
        </FormWrapper>
      )}
    />
  );
}
